import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { BehaviorSubject, of, Subject } from "rxjs";
import { AssetClassTenureModel } from "src/app/core/asset_class";
import { AssetClassTenure } from "src/app/core/comparable";
import { AssetClassSize, Consideration } from "src/app/core/v2/types";
import { ConsiderationAndSourceComponent } from "../consideration-and-source/consideration-and-source.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'kt-land-consideration-list',
  templateUrl: './land-consideration-list.component.html',
})
export class LandConsiderationListComponent implements OnInit, OnDestroy {
  @ViewChild(ConsiderationAndSourceComponent)
  considerationAndSource: ConsiderationAndSourceComponent

  private _considerations$ = new BehaviorSubject<AssetClassTenure[]>([])
  considerations$ = this._considerations$.asObservable()
  @Input()
  set considerations(values: AssetClassTenure[]) {
    this._considerations$.next(values)
  }

  private _sizes$ = new BehaviorSubject<AssetClassSize[]>([]);
  sizes$ = this._sizes$.asObservable()
  @Input()
  set sizes(value: AssetClassSize[]) {
    this._sizes$.next(value)
  }
  @Input()
  tenureSubject: BehaviorSubject<AssetClassTenureModel>;

  hasParcel$ = of(false)
  comps$ = new BehaviorSubject([])

  form = new FormGroup({
    current_occupier: new FormControl(null),
    previous_occupier: new FormControl(null),
    rrr_over_land:  new FormControl(null),
    additional_rrr_over_land: new FormControl(null),
    difference_between_boundaries: new FormControl(null),
  })

  private _onDestroy$ = new Subject<void>()

  ngOnInit(): void {
    this.tenureSubject.asObservable().pipe(
      takeUntil(this._onDestroy$)
    ).subscribe(res => {
      this.form.patchValue({
          current_occupier: res.current_occupier,
          previous_occupier: res.previous_occupier,
          rrr_over_land: res.rrr_over_land,
          additional_rrr_over_land: res.additional_rrr_over_land,
          difference_between_boundaries: res.difference_between_boundaries,
      })
    })
  }

  ngOnDestroy(): void {
    this._onDestroy$.next()
    this._onDestroy$.complete()
  }

  updateValue(isComplete: boolean) {
    if (isComplete && !this.valid()) {
        return
    }
    const controls = this.form.controls;

    const acTenure = new AssetClassTenureModel();
    acTenure.clear();
    acTenure.current_occupier = controls.current_occupier.value;
    acTenure.previous_occupier = controls.previous_occupier.value;
    acTenure.rrr_over_land = controls.rrr_over_land.value;
    acTenure.additional_rrr_over_land = controls.additional_rrr_over_land.value;
    acTenure.difference_between_boundaries = controls.difference_between_boundaries.value;

    this.tenureSubject.next(acTenure);
  }
  valid(): boolean {
    let isValid = true;
    const controls = this.form.controls;
    return isValid;
  }

  getData() {
    if (this.considerationAndSource) {
      return this.considerationAndSource.getData()
    }
    return []
  }
}